let logo = null;

export function setLogo(val) {
  logo = val;
}

export function getLogo() {
  return logo;
}
